import { gql } from '@apollo/client'

export const GET_CHART_DATA = gql`
    query GetChartData($input: GetGraphDataInput) {
        getGraphData(input: $input) {
            bank {
                date
                value
            }
            crypto {
                date
                value
            }
            balance
            balanceDate
        }
    }
`
